import React from "react";

import classes from './ResultsHeader.module.css';

import { Row, Col } from 'react-bootstrap';
import { useTranslation } from "react-i18next";

const ResultsHeader = (props: any) => {
  const { t } = useTranslation();

  return (
    <Row
      ref={props.resultsRef}
      className={classes.resultsHeader}>
      <Col md="8">
        <div  className={classes.resultsTitle}>
          {t("num_results_header", { num: props.totalCount})}
        </div>
      </Col>
    </Row>
  );
};

export default ResultsHeader;
